import React from "react";
import { useFormContext } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import styled from "styled-components";

export const Error = styled.strong`
  font-size:  ${(props) => props.fontSize || "15px"} !important;
  font-family: "Futura-Medium", Arial, Helvetica, sans-serif;
  color: #cf0e18 !important;
  line-break: normal;
  width: ${(props) => props.width || "100%"} !important;
`;

const SimpleErrorMessage = ({ name,fontSize }) => {
  const { errors } = useFormContext();
  return (
    <ErrorMessage
      name={name}
      errors={errors}
      render={({ message }) => <Error fontSize={fontSize}>{message}</Error>}
    />
  );
};

export default SimpleErrorMessage;
